import Tooltip from '@/ui/Tooltip'
import { Fragment } from 'react'
import { BranchOptionSecondaryButton } from './BranchOptionSecondaryButton'
import { PrimaryButton2ChoicesFive } from './PrimaryButton2ChoicesFive'
import { playbookBranchOptionModel } from './playbookBranchOptionModel'
import { getOptionsGridTemplateColumns } from './getOptionsGridTemplateColumns'
import { resolveBranchChoiceDomId } from './resolveBranchChoiceDomId'
import { type PlaybookBranchChoicesGridProps } from './playbookBranchChoicesTypes'

// Desktop layout when three or more plans appear: a single dynamic-track row of plan buttons.
export const DesktopPlaybookBranchChoicesFive = ({
  nodeId,
  options,
  nextNodeId,
  defaultPrimaryTargetId,
  selectedPath,
  currentPathIndex,
  nodes,
  onSelect,
  onPlanHover,
  onBranchHover,
  expandedPlanLayout,
  onGridMouseLeave,
  showPrimaryHoverStyleByDefault,
}: PlaybookBranchChoicesGridProps) => {
  const branchChoiceElementId = resolveBranchChoiceDomId(nodeId)
  const gridTemplateColumns = getOptionsGridTemplateColumns(options, nodes, expandedPlanLayout)
  return (
    <div
      id={branchChoiceElementId}
      data-branch-choice-ids={options.map(o => o.targetId).filter(Boolean).join(',')}
      className="flex -mx-[5px] items-start"
      style={{ gridTemplateColumns }}
      onMouseLeave={onGridMouseLeave}
    >
      {options.map((option) => {
        const optionProps = {
          option,
          isSelected: nextNodeId === option.targetId || defaultPrimaryTargetId === option.targetId,
          selectedPath,
          currentPathIndex,
          nodes,
          onSelect,
          onPlanHover,
          onBranchHover,
          disableTooltip: expandedPlanLayout,
        }
        const { disableTooltip } = optionProps
        const m = playbookBranchOptionModel(optionProps)
        // The px-[5px] wrapper (not a flex gap) owns the space between plans
        // AND the hover handlers, so mousing from one plan to the next never
        // crosses dead space that would clear the hover back to the default
        // plan.
        const button = (
          <div
            className="flex-1 flex px-[5px]"
            onPointerEnter={m.handlePointerEnter}
            onPointerLeave={m.handlePointerLeave}
          >
            {m.isPrimary ? (
              <PrimaryButton2ChoicesFive
                option={option}
                targetNode={m.targetNode}
                inverted={m.inverted}
                showHoverStyleByDefault={showPrimaryHoverStyleByDefault}
                showPreviewChevron={expandedPlanLayout && (!nextNodeId || nextNodeId === option.targetId)}
                onClick={m.handleClick}
              />
            ) : (
              <div className="flex-1">
                <BranchOptionSecondaryButton
                  option={option}
                  targetNode={m.targetNode}
                  inverted={m.inverted}
                  onClick={m.handleClick}
                />
              </div>
            )}
          </div>
        )
        const choiceKey = option.targetId || 'null'
        if (!m.tooltipContent || disableTooltip) {
          return <Fragment key={choiceKey}>{button}</Fragment>
        }
        return (
          <Tooltip key={choiceKey} content={m.tooltipContent}>
            {button}
          </Tooltip>
        )
      })}
    </div>
  )
}
